import { combineReducers } from "redux";
import infraMonitor from "infraMonitor";
import projectsStatsReducers from "infraMonitor/projects-stats";
import localizationReducers from "./infraMonitor/localization";
import fiscalYearReducers from "./infraMonitor/fiscalyear";
import staticData from "./infraMonitor/staticData";
import localInfraMonitorReducers from "./infraMonitor/localReducers";

export default combineReducers({
  infraMonitor,
  projectsStatsReducers,
  localizationReducers,
  fiscalYearReducers,
  staticData,
  localInfraMonitor: localInfraMonitorReducers,
});



// WEBPACK FOOTER //
// ./src/reducer.js